export const CreditReviewInformationFields = {
	chargebackVolume: "chargeback_volume",
	riskExposure: "risk_exposure",
	reserve: "reserve",
	reserveAmount: "reserve_amount",

	deliverySameDay: "delivery_same_day",
	deliveryFromOneToThreeDays: "delivery_from_one_to_three_days",
	deliveryFromFourToSevenDays: "delivery_from_four_to_seven_days",
	deliveryFromEightToFourteenDays: "delivery_from_eight_to_fourteen_days",
	deliveryFromFifteenToThirtyDays: "delivery_from_fifteen_to_thirty_days",
	deliveryOverThirtyDays: "delivery_over_thirty_days",
};

export const daysToDeliveryFieldsNames = [
	CreditReviewInformationFields.deliverySameDay,
	CreditReviewInformationFields.deliveryFromOneToThreeDays,
	CreditReviewInformationFields.deliveryFromFourToSevenDays,
	CreditReviewInformationFields.deliveryFromEightToFourteenDays,
	CreditReviewInformationFields.deliveryFromFifteenToThirtyDays,
	CreditReviewInformationFields.deliveryOverThirtyDays,
];
